export default __webpack_public_path__ + "static/media/coupon.ffb8cf78.png";